import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { SeoState, initialState, SEO_SLICE_NAME } from './models';
import { getRobotsData, updateRobotsData } from './actionCreators';

export const slice = createSlice({
  name: SEO_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRobotsData.fulfilled, (state: SeoState, action) => {
        state.robotsData = action.payload.data;
        state.isLoading = false;
      })
      .addCase(updateRobotsData.fulfilled, (state: SeoState, action) => {
        state.robotsData = action.payload.data;
        state.isLoading = false;
      })
      .addMatcher(isPending(getRobotsData, updateRobotsData), (state: SeoState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getRobotsData, updateRobotsData), (state: SeoState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;
